type Props = {[key: string]: any};
type ComponentWithProps = [React.ComponentType<any>, Props?];

export const buildProvidersTree = (
  componentsWithProps: ComponentWithProps[],
): React.ComponentType<{children?: React.ReactNode}> => {
  const initialComponent: React.FC<{children?: React.ReactNode}> = ({
    children,
  }) => <>{children}</>;

  return componentsWithProps.reduce(
    (AccumulatedComponents, [Provider, props = {}]) => {
      const Component: React.FC<{children?: React.ReactNode}> = ({
        children,
      }) => (
        <AccumulatedComponents>
          <Provider {...props}>{children}</Provider>
        </AccumulatedComponents>
      );
      return Component;
    },
    initialComponent,
  );
};
